import axios from 'axios';

axios.defaults.baseURL = process.env.PUBLIC_URL;
